import React from "react";

const PicnicRightArea = ({ dishFlag, greenFlagItems, redFlagItems }) => {
  return (
    <div className="picnic-right-area">
      {dishFlag === "" && (
        <div className="side-instructions-wrapper">
          <h4 className="side-instructions-head">Instructions</h4>

          <div className="side-instructions-para">
            <p>
              <strong>Step 1:</strong> Select dish type (appliance) you want to
              use to make your food.
            </p>
            <p>
              <strong>Step 2:</strong> Select level 1 ingredient.
            </p>
            <p>
              <strong>Step 3:</strong> Select level 2 ingredient.
            </p>
            <p>
              <strong>Step 4:</strong> Select level 3 ingredient.
            </p>
            <p>
              <strong>Step 5:</strong> Select level 4 ingredients.
            </p>
            <p>
              <strong>Step 6:</strong> Click Bake / Cook / Grill / Blend.
            </p>
          </div>
        </div>
      )}

      {dishFlag !== "" && (
        <>
          <div className="final-dish-ingredients">
            <div>
              <strong>Healthy items:</strong>
            </div>
            <div className="used-item-wrapper">
              {greenFlagItems.length > 0
                ? greenFlagItems.map((item, i) => {
                    return <span key={i}>{item}</span>;
                  })
                : "No healthy items used!"}
            </div>
          </div>
          <div className="final-dish-ingredients">
            <div>
              <strong>Un-healthy items:</strong>
            </div>
            <div className="used-item-wrapper">
              {redFlagItems.length > 0
                ? redFlagItems.map((item, i) => {
                    return <span key={i}>{item}</span>;
                  })
                : "No unhealthy items used!"}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PicnicRightArea;
